<div class="alert alert-info">
    {{ text }}
</div>
